<div *ngIf="componentHTML !== null"
     [innerHTML]="componentHTML | safe: 'html'"></div>